export default __webpack_public_path__ + "static/media/support.18630ef5.svg";